interface HelmetProps {
  title: string;
  description: string;
  keywords: string;
  canonicalUrl: string;
  ogType?: string;
  ogImage?: string;
}

export function Helmet({ title, description, keywords, canonicalUrl, ogType = 'website', ogImage }: HelmetProps) {
  const fullTitle = title.includes('被窝网电影') ? title : `${title} - 被窝网电影`;
  const baseUrl = 'https://www.beiwomovie.com';

  return (
    <>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <link rel="canonical" href={`${baseUrl}${canonicalUrl}`} />
      <meta property="og:type" content={ogType} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={`${baseUrl}${canonicalUrl}`} />
      {ogImage && <meta property="og:image" content={ogImage} />}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      {ogImage && <meta name="twitter:image" content={ogImage} />}
      <meta name="robots" content="index, follow" />
    </>
  );
}